import { FlexBox, QuoteView, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { UserPost } from '@fable/types'
import { useNavigate } from 'react-router-dom'
import { routes } from 'app/social/routes'
import {
  ActivityPostBody,
  ActivityPostImage,
  ActivityUser,
  getPostUserProps,
} from 'components/activity'

interface Props {
  className?: string
  post: UserPost
}

export const ProfilePost = ({ post, className }: Props) => {
  const navigate = useNavigate()
  const { colors, motion } = useTheme()
  const isEditorial = post.content_type === 'editorialPost'
  const userProps = getPostUserProps({ post })

  return (
    <FlexBox
      className={cx(
        css`
          padding: 20px;
          background-color: ${colors.uiWhite};
          border-radius: 8px;
          cursor: pointer;
          ${motion.transition(['transform', 'box-shadow'])};
          &:hover {
            ${motion.moveY(-10)}
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.02);
          }
        `,
        className
      )}
      onClick={() => navigate(`${routes.post}/${post.id}`)}
      flexDirection="column"
      gap="20px"
    >
      <ActivityUser {...userProps} small />
      {isEditorial && post.title.length ? (
        <Text
          type="header"
          sizing={{ base: 'XS', tablet: 'S' }}
          color={colors.uiGraphite}
          truncate={3}
        >
          {post.title}
        </Text>
      ) : null}
      {post.featured_image ? (
        <ActivityPostImage image={post.featured_image} contain />
      ) : null}
      {!isEditorial && post.body.length ? (
        <ActivityPostBody body={post.body} truncate={10} stopPropagation />
      ) : null}
      {post.image && !post.quotes?.length ? (
        <ActivityPostImage image={post.image} contain />
      ) : null}
      {!!post.quotes?.length ? (
        <QuoteView
          text={post.quotes[0].text}
          book={post.quotes[0].book}
          theme={post.quotes[0].theme}
        />
      ) : null}
    </FlexBox>
  )
}
